var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.75C5.48438 14.75 3.1875 13.4375 1.92969 11.25C0.671875 9.08984 0.671875 6.4375 1.92969 4.25C3.1875 2.08984 5.48438 0.75 8 0.75C10.4883 0.75 12.7852 2.08984 14.043 4.25C15.3008 6.4375 15.3008 9.08984 14.043 11.25C12.7852 13.4375 10.4883 14.75 8 14.75ZM6.90625 9.9375C6.52344 9.9375 6.25 10.2383 6.25 10.5938C6.25 10.9766 6.52344 11.25 6.90625 11.25H9.09375C9.44922 11.25 9.75 10.9766 9.75 10.5938C9.75 10.2383 9.44922 9.9375 9.09375 9.9375H8.875V7.53125C8.875 7.17578 8.57422 6.875 8.21875 6.875H6.90625C6.52344 6.875 6.25 7.17578 6.25 7.53125C6.25 7.91406 6.52344 8.1875 6.90625 8.1875H7.5625V9.9375H6.90625ZM8 4.25C7.50781 4.25 7.125 4.66016 7.125 5.125C7.125 5.61719 7.50781 6 8 6C8.46484 6 8.875 5.61719 8.875 5.125C8.875 4.66016 8.46484 4.25 8 4.25Z",
    fill: "#4B5EAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.3198fa35db41a0d70c2505aed3802621.svg";
export { ForwardRef as ReactComponent };